import { Component, OnInit } from "@angular/core";
import { DialogService } from "primeng/dynamicdialog";
import { UserService } from "../../../../shared";
import { DataService_AdvancedPreferences } from "../shared/data.service";

@Component({
	selector: "caass-prefs-school-table",
	templateUrl: "./prefs-school-table.component.html",
	styleUrls: ["./prefs-school-table.component.css"],
})
export class PrefsSchoolTableComponent implements OnInit {
	constructor(private userService: UserService, private PrefsSchoolTableService: DataService_AdvancedPreferences, private dialogService: DialogService) {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		this.loadSchool();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 5;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedSchools: any;
	lstSchool: any = [];

	//Filter lists

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "SchoolID", header: "School ID" },
		{ field: "SchoolNumber", header: "School Number" },
		{ field: "SchoolName", header: "School Name" },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	loadSchool() {
		var result = this.PrefsSchoolTableService.LoadAllSchools();
		result.subscribe(
			(response) => {
				this.lstSchool = response;

				//Load Data Filter Lists
			},
			(error) => {}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {}
	onRowUnselect(val) {}
	////////////////////////////////////////////
}
